import axios from "axios";
import baseUrl from "../config/baseURL";
import { getAuthToken } from "../services/auth";

export const getOrganizationSubscription = async (organization_id: any) => {
    let token = await getAuthToken();
    try {
        if(token){
            let header_token = "Bearer " + token.data;
            const headers = {
                Authorization: header_token,
            };
        try {
            const endpoint = `${baseUrl}/core/organizations/${organization_id}/subscription/`;
            const response = await axios.get(endpoint,{ headers });
            if (response.status>=200 && response.status <=400) {
            return {"success":true, "data": response?.data};
            } else {
            console.error("Data retrieval failed here:", response, response.data);
            return {"success":false, "data": response?.data};
            }
        } catch (error) {
            console.error("An unexpected error occurred:", error);
            return {"success":false, "data": error};
        }
        }else{
        return {"success":false, "data": "error: Token does not exist"};
        }
        
    }catch (error) {
        console.error("Unexpected error occurred while fetching the leads:", error);
        return {"success":false, "data": undefined};
    }
};

export const updateOrganizationSubscription = async (organization_id: any, updatedData: any) => {
    let token = await getAuthToken();
    try {
        if(token){
            let header_token = "Bearer " + token.data;
            const headers = {
                Authorization: header_token,
            };
        try {
            const endpoint = `${baseUrl}/core/organizations/${organization_id}/subscription/upgrade/`;
            const response = await axios.post(endpoint,updatedData, { headers } );
            if (response.status>=200 && response.status <=400) {
            return {"success":true, "data": response?.data};
            } else {
            console.error("Data retrieval failed here:", response, response.data);
            return {"success":false, "data": response?.data};
            }
        } catch (error) {
            console.error("An unexpected error occurred:", error);
            return {"success":false, "data": error};
        }
        }else{
        return {"success":false, "data": "error: Token does not exist"};
        }
        
    }catch (error) {
        console.error("Unexpected error occurred while fetching the leads:", error);
        return {"success":false, "data": undefined};
    }
};


export const saveOrganizationSubscription = async (
  orgId: string,
  tier: string,
  is_trial: boolean,
  trial_days: number,
) => {
  const data = {
    "tier": tier,
    "is_trial": is_trial,
    "trial_days": trial_days,
  };
  let token = await getAuthToken();
  let headers;

  if(token){
    let header_token = "Bearer " + token.data;
    headers = {
        Authorization: header_token,
    };
  }

  try {
    const endpoint = `${baseUrl}/core/organizations/${orgId}/subscription/`;
    const response = await axios.post(endpoint, data, {headers});

    if (response.status === 201) {
      console.log("Organization subscription created successfully:", response.data);
      return { success: true, data: response.data };
    } else {
      console.error("Error experienced creating org sub:", response.data);
      return { success: false, data: response.data };
    }
  } catch (error: any) {
    console.error("An unexpected error occurred:", error?.response?.data || error);
    return { success: false, data: error?.response?.data || error };
  }
};

export const getOrganizationPaymentHistory = async (organization_id: any) => {
    let token = await getAuthToken();
    try {
        if(token){
            let header_token = "Bearer " + token.data;
            const headers = {
                Authorization: header_token,
            };
        try {
            const endpoint = `${baseUrl}/core/organizations/${organization_id}/subscription`;
            const response = await axios.get(endpoint,{ headers });
            if (response.status>=200 && response.status <=400) {
            return {"success":true, "data": response?.data};
            } else {
            console.error("Data retrieval failed here:", response, response.data);
            return {"success":false, "data": response?.data};
            }
        } catch (error) {
            console.error("An unexpected error occurred:", error);
            return {"success":false, "data": error};
        }
        }else{
        return {"success":false, "data": "error: Token does not exist"};
        }
        
    }catch (error) {
        console.error("Unexpected error occurred while fetching the leads:", error);
        return {"success":false, "data": undefined};
    }
};
